import { ChipIcon } from "@heroicons/react/solid";
import React from "react";
import { skills } from "../data";

export default function Skills() {
  return (
    <section  id="skills">
      <div data-aos="zoom-in" data-aos-duration="1500" className="container px-5 py-10 mx-auto">
        <div className="text-center mb-20">
          <ChipIcon className="w-10 inline-block mb-4" />
          <h1 className="sm:text-4xl text-3xl font-medium title-font text-white mb-4">
            Skills &amp; Technologies
          </h1>
        </div>
       
        <div className="flex flex-wrap lg:w-4/5 sm:mx-auto sm:mb-2 -mx-2">
          {skills.map((skill,i) => (
            <div key={i} className="p-2 sm:w-1/3 w-full " >
              <div className="bg-gray-800 rounded flex p-2 items-center">
             <img className=" w-10 h-10 flex-shrink-0 mr-4" alt="abc" src={skill.img}/>
                <span className="title-font font-medium text-white">
                  {skill.name}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
   
    </section>
  );
}



// WEBPACK FOOTER //
// ./src/components/Skills.js